module.exports = __webpack_public_path__ + "img/gallery09.a2b3486a.png";